// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Particle_Css = require("./Particle_Css.bs.js");

function toRules(device) {
  return [Particle_Css.getDeviceMediaQuery(device)];
}

exports.toRules = toRules;
/* Particle_Css Not a pure module */
